import imageCompression from "browser-image-compression";

export async function compressImage(file) {
  const options = {
    maxSizeMB: 1, // Max file size in MB
    maxWidthOrHeight: 800, // Max resolution
    useWebWorker: true, // Use web worker for performance
  };

  try {
    const compressedFile = await imageCompression(file, options);
    // console.log("Compressed File:", compressedFile);

    return compressedFile;
  } catch (error) {
    console.error("Compression failed:", error);
  }
}
